import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { StateService } from './state.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    console.error('Global Error:', error);
    this.sendToServer(error);
  }

  private sendToServer(error: any) {
    const stateService = this.injector.get(StateService);
    fetch(
      'https://bbfd-dfb7atckdjapfdbt.z03.azurefd.net/api/v0/configuration/error',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: error.message,
          stack: error.stack,
          user: stateService.userName,
          version: stateService.version,
        }),
      }
    );
  }
}
